export const en = {
  docTitle: 'Dora the Octopus | {{name}}',
  invite: {
    title: 'Dora the Octopus',
    subtitle: 'What kind of project you are working on, my friend?',
    continueBtn: 'Accept invitation',
    accept: {
      alreadyAcceptedError:
        'This invitation was already accepted. You can directly login with your username & password!',
      title: 'Account Activation',
      subtitle: '{{ name }}, enter a password to get started 🤗',
      password: 'Your favourite password',
    },
  },
  auth: {
    forgotPassword: 'Forgot password?',
    backToLogin: '👈 back to Login',
    changePassSubmit: 'Change password',
    resetPassSuccessMessage:
      'We sent password change instructions to your email.',
    newPass: 'New password',
    repeatPass: 'Repeat password',
    newPassSubmit: 'Confirm new password',
    errPasswordsNotMatching: 'The two passwords do not match!',
  },
  onboarding: {
    addProjects: {
      title: 'What projects are you working on?',
      subtitle: 'Step 1 of 3',
      joinProject: 'Join in some of the already added projects:',
      addProject: '... or, if yours are missing, add a new one:',
      addProjectBtn: '+ new project',
      modalTitle: 'New Project',
    },
    addSideProjects: {
      title: 'Do you work on any side projects or your own projects maybe?',
      subtitle: 'Step 2 of 3',
      joinProject: 'Join in some of the already added side projects:',
      addProject: '... or, if yours are missing, add a new one:',
      addProjectBtn: '+ new project',
      modalTitle: 'New Side Project',
    },
    addGoals: {
      title: 'What are your goals?',
      subtitle: 'Step 3 of 3',
      addGoals: 'Share your goals',
      addedGoals: 'You goals:',
      continueBtn: 'Finish',
    },
  },
  home: {
    title: 'Homeland.',
    subtitle: 'Contains all the latest news since the previous newsletter.',
    message:
      'All of these will be packed in a newsletter and sent out {{comingIn}}.',
    newMembersTitle: 'Newcomers',
    newProjectsTitlePrefix: '',
    newProjectsTitle: 'latest',
    newProjectsTitleSuffix: ' [Projects]',
    newSideProjectsTitlePrefix: '',
    newSideProjectsTitle: 'latest',
    newSideProjectsTitleSuffix: ' {Side Projects}',
    newSideProjectsTitleSuffixSecondary: ' projects',
    projectsEventsTitle: 'Activity around all projects',
    goalsTitlePrefix: '',
    goalsTitle: 'Activity around all',
    goalsTitleSuffix: ' <Goals>',
    noneEvents:
      'There are still no updates for the current period. Be cool! Post an update!',
    noneEventsTitle: "Nobody's home",
    newsletterArchive:
      'Previous updates can be found in the time capsule (archive with all the newsletters sent)',
  },
  users: {
    titlePrefix: 'Dream',
    title: ' Team',
    titleSuffix: '',
  },
  footer: {
    note: 'Have any questions? Feedback? ',
    noteCallToAction: 'Message us.',
    createdBy: 'Made with ❤ and ⌨ by',
    createdByUrl: 'Dev___SPACE___Labs',
  },
  user: {
    viewProfile: 'Go to Profile',
    editProfile: 'Edit your profile',
    editProfileTitle: 'Edit your profile',
    projectsTitlePrefix: '[Active Projects]',
    projectsTitle: ', the user works on',
    projectsTitleSuffix: '',
    sideProjectsTitlePrefix: '{Side Projects}',
    sideProjectsTitle: ', the user works on',
    sideProjectsTitleSuffix: '',
    archievedProjectsTitlePrefix: '<!-- Inactive -->',
    archievedProjectsTitle: ' Projects',
    archievedProjectsTitleSuffix: '',
    goalsTitlePrefix: '',
    goalsTitle: '',
    goalsTitleSuffix: '<Goals>',
    joinOrAddProjectBtn: '+ new project',
    noneProjectsAdded: 'None. Come on, share! 🤗',
    joinProjectLabel: 'Join in an already added project',
    addProjectLabel: 'or add a new one:',
    addOrJoinProjectTitle: 'New Project',
    noneGoalsAdded: 'None.',
    noneGoalsAddedMotivation:
      "Studies show that the chance of achieving your goals is greatly increased when you share them with others. Some of the reasons are: 1) You gain clarity; 2) You receive accountability; 3) You get a progress measurement and motivation; 4) You connect to like-minded people. So, why don't you share them? 🤗",
    edit: {
      nameLabel: 'Name',
      namePlaceholder: '',
      emailLabel: 'E-mail',
      avatarLabel: 'Avatar. Square photos work best.',
      avatarPlaceholder: 'Come on, post a photo :)',
      urlsLabel: 'Your links, divided, by, a, comma',
      urlsPlaceholder: 'https://..., https://..., https://...',
      lang:
        'Language for the UI. You can change it for yourself, but Newsletters and other general messages will always be in the official language of your team.',
    },
  },
  events: {
    project: {
      join: 'started working on',
      join_plural: 'started working on',
      unjoin: 'no longer works on',
      unjoin_plural: 'no longer work on',
      unjoinWithMultiple: 'no longer works on this one.',
      unjoinWithMultiple_plural: 'no longer work on this one.',
      addMemo: 'shared',
      sharedMemo: 'shared in the lexicon',
      projectsMemoOwn: 'of',
    },
    goal: {
      label: '(1){goal};(2-inf){goals};',
      update: 'updated',
      sharedGoalMemos: 'shared the following things:',
      sharedForGoal: "in relation to one's goal:",
    },
  },
  nav: {
    projects: 'Projects',
    users: 'Team',
    newsletters: 'Archive',
    menu: 'Menu',
    admin: 'Admin',
  },
  newsletter: {
    archieveTitle: 'Time Capsule',
    archieveSubtitle: 'Archive of all the newsletters already sent',
    archieveEmptyTitle: "But there aren't any yet",
    archieveEmptySubtitle:
      'No newsletters have been sent so far. I look forward to the first one 🤗',
    itemTitle: 'Newsletter #{{number}}',
    comingIn: 'Newsletter {{comingIn}}',
    remaining: '{{count}} day',
    remaining_plural: '{{count}} days',
    manageYourUpdates: 'Your updates',
    confirmYourInfo: '👉 confirm your info 👈',
  },
  admin: {
    adminTitle: 'Hello, boss! 👀',
    adminSubtitle: 'Manage. Personalize. Invite others to join.',
    title: 'All invites',
    addNewMemberBtn: 'Invite new member',
    editInviteModalTitle: 'Edit Invite',
    editInviteModalBtn: 'Save changes',
    copyLinkBtn: 'Copy URL',
    copyLinkSuccess: 'Coplied!',
    cancelBtn: 'Cancel',
    undoCancelBtn: 'Activate again',
    invites: 'Invites',
    inviteStatusLabel: {
      SENT: 'Invite sent! Waiting for the other person to act.',
      CANCELED: 'Invite cancelled!',
      ACCEPTED: 'Invite accepted!',
    },
    inviteAvatarUploadEdgeCase:
      "We sent the invitation successfully but there is a problem with the avatar. Here's what we know: {{error}}. If you wish, try again by editing the invitation.",
    userName: 'User',
    userEmail: 'E-mail',
    userStatus: 'Status',
    settings: 'Settings',
    settingsTitle: 'Workspace Settings',
    mainSettingsTitle: 'Main Settings',
    mailSettingsTitle: 'Mail Settings',
    settingsScreen: {
      loginScreenTitle: 'Workspace Login Screen',
      onboardingScreenTitle: 'On-boarding Screen',
      subscriptionScreenTitle: 'Subscription & Billing',
      logo: 'Logo',
      logoPlaceholder: 'https://...',
      background: 'Background image. Appears on the Workspace Login Screen.',
      backgroundPlaceholder: 'https://...',
      name: 'Name',
      namePlaceholder: '',
      officialLang:
        'Official language. Newsletters to the team and other general messages will be in that language.',
      updatePeriod:
        'Update period. In the end of each period, a newsletter will be send. If you want to change it, please contact support.',
      helloMessage:
        'Greeting. One-liner. Appears on the Workspace Login Screen.',
      helloMessagePlaceholder: 'Welcome everyone to our sharing temple!',
      onboardingMessage:
        'Right after each member opens his invite link - these are the words he will see. Great place for some extra personalized motivation. Supports HTML.',
      slogan: 'Slogan. Appears on the Workspace Login Screen.',
      sloganPlaceholder: '',
      emailInvite: {
        title: 'Invite e-mail',
        subject: 'Subject',
        message: 'Content',
      },
      emailReminders: {
        title: 'Reminder e-mail',
        descr:
          "Only users who haven't yet confirmed their info yet (haven't went through the Fake News mechanism) receive these. Gets send: 3 and 1 day before the newsletter gets send.",
        subject: 'Subject',
        message: 'Content',
      },
      emailStats: {
        title: 'Stats e-mail',
        descr:
          'Only admins receive these. Gets send: 3 and 1 day before the newsletter gets send.',
        subject: 'Subject',
        message: 'Content',
      },
      slack: {
        on: 'Enabled',
        off: 'Disabled',
        title: 'Slack Integration',
        reminder:
          'Slack bot reminder. Gets send: 6, 3 and 1 day before the newsletter gets send.',
        thanks: 'Thanks note. Gets send right after the newsletter gets send.',
        slackBotSettingsTitle: 'Slack Bot Settings',
        singleUpdatesTitle: 'Slack Bot Updates',
        singleUpdatesDescr:
          'Slack Bot updates immediately when something happens',
        liveUpdates: {
          ADD_USER: 'When somebody joins the workspace',
          ADD_PROJECT: 'When a new project is added',
          JOIN_PROJECT: 'When somebody starts working on a project',
          UNJOIN_PROJECT: 'When somebody no longer works on a project',
          ADD_PROJECT_MEMO:
            'When somebody shares something in a project Lexicon',
          ADD_GOAL_MEMO:
            'When somebody shares something related to one of his goals',
          ADD_GOAL: 'When somebody adds a new goal',
          COMPLETE_GOAL: 'When somebody completes his goal',
        },
      },
      msteams: {
        on: 'Enabled',
        off: 'Disabled',
        title: 'Microsoft Teams Integration',
        reminder:
          'Bot reminder. Gets send: 6, 3 and 1 day before the newsletter gets send.',
        thanks: 'Thanks note. Gets send right after the newsletter gets send.',
        settingsTitle: 'Bot Settings',
        singleUpdatesTitle: 'Bot Updates',
        singleUpdatesDescr: 'Bot updates immediately when something happens',
        liveUpdates: {
          ADD_USER: 'When somebody joins the workspace',
          ADD_PROJECT: 'When a new project is added',
          JOIN_PROJECT: 'When somebody starts working on a project',
          UNJOIN_PROJECT: 'When somebody no longer works on a project',
          ADD_PROJECT_MEMO:
            'When somebody shares something in a project Lexicon',
          ADD_GOAL_MEMO:
            'When somebody shares something related to one of his goals',
          ADD_GOAL: 'When somebody adds a new goal',
          COMPLETE_GOAL: 'When somebody completes his goal',
        },
      },
      subscription: {
        planTitle: 'Current plan:',
        plan: {
          TRIAL: 'Trial period. Free 🤗',
          EARLY_ADOPTER: 'Early Adopter. Free 🤗',
          REGULAR: 'Active subscription ✅',
          FOREVER_FREE: 'Free 🤞',
        },
        periodTitle: 'Subscription period:',
        slotsTitle: 'Activated users:',
        valueTitle: 'Subscription value:',
        valueText: '{{userSlots}} users * €4 = ',
        valueSum: '€{{value}} monthly',
        transferTitle: 'Bank transfer details:',
        bank: {
          recepient: 'BG Leads Ltd',
          bank: 'PROCREDIT Bank',
          bic: 'PRCBBGSF',
          iban: 'BG88 PRCB 9230 1419 3963 18 (EUR)',
        },
        contactTitle: 'Contact person:',
        mobileTitle: 'Mobile:',
        mailTitle: 'E-mail:',
        contact: {
          name: 'Kaloyan Kosev',
          phone: '+359 883 352 972',
          email: 'superkalo@devlabs.bg',
        },
        clarification:
          '👋 When you make a bank transfer, please send an email to the contact person below. Then, you will receive a confirmation and an invoice for your subscription.',
        payNowWarn:
          "Your team's current subscription period has expired. Please order a payment for the next period.",
        lockedTitle: 'Workspace is Locked',
        lockedTextLine1: 'Your team subscription was terminated.',
        lockedTextLine2:
          'If you think this is a mistake, please contact your team administrator.',
      },
    },
    edit: {
      sentInvite: 'Send invite',
    },
  },
  manageUpdates: {
    titleConfirm: 'We need your contribution',
    subtitleConfirm:
      'Take a few moments to confirm the info we have for you. This is a mechanism to fight fake news together.',
    title: 'Your current updates',
    subtitleConfirmed: 'This is a mechanism to fight fake news together.',
    titleConfirmed: "You're confirmed ✅",
    subtitle:
      "These are the things you've shared since the previous newsletter.",
    currentUpdatesTab: 'Your current updates',
    confirmTab: 'Fake News Mechanism',
    confirmTabNote: '(will be active in {{ count }} day)',
    confirmTabNote_plural: '(will be active in {{ count }} days)',
    confirmTabNoteActive: '(active now)',
    confirmTabTitle: 'Confirm that you are still working on:',
    tooltipStillWorkingOn: 'I still work on this project',
    tooltipNoLongerWorkingOn: 'I NO LONGER work on this project',
    goalsTitlePrefix: '',
    goalsTitle: 'Updates for your ',
    goalsTitleSuffix: '<Goals>',
    projectsTitlePrefix: '',
    projectsTitle: 'Updates for your Projects',
    projectsTitleSuffix: '',
    noGoalUpdates: 'No updates.',
    noProjectUpdates: 'No updates.',
    remove: {
      projectModalTitle: 'Remove an update for a project',
      projectModalNote:
        'Remove only as a last resort if a mistake has occurred. In all other cases - maybe the change of status - you are actively working or not working on this project is a better solution?',
      goalModalTitle: 'Remove an update for a goal',
      goalModalNote: 'Remove only as a last resort if a mistake has occurred.',
    },
    confirmNoUpdates: {
      title: 'None active projects?',
      note:
        "I don't believe you. Do not act crazy! Go to your profile and add a project that you are currently working on. Then come back here and confirm.",
      btnTitle: 'Sorry, none active projects indeed 😕',
    },
    confirmSuccess: {
      title: "You're confirmed!",
      note:
        'Thanks for sharing! You are super cool! Remember - if you started a new project or there is another innovation around you, you can always add it.',
    },
    confirmNotYetTheTime: {
      title: 'Will be active in {{count}} day',
      title_plural: 'Will be active in {{count}} days',
      note:
        'A week before sending the newsletter, I will ask everyone to confirm if still works actively on the same projects. And if one would like to share something in project Lexicons. The process takes not more than a few minutes :)',
    },
    userStatus: {
      stillWorkingOnTitle: 'You still work on {{project}} ✅',
      stillWorkingOnMessage: [
        'Did you finish any feature?',
        'Did you get anything interesting during the month?',
        'When do you plan to launch the project?',
        'Do you think you will fir in your estimation?',
        "What's the biggest challenge for you so far?",
        'Do you like the customer so far?',
        'Do you use any new library, tool or a framework?',
        'What is your role in the project?',
        'What is your favorite feature in the project?',
        'Is there something you did extremely well in this project?',
        'Is there anything that could be better?',
        'What would you change if you could rewrite the project?',
      ],
      noLongerWorkingOnTitle: 'You no longer work on {{project}} 👍',
      noLongerWorkingOnMessage: [
        'What useful did you learn?',
        'What was the biggest challenge for you?',
        'Did you fit in the original estimation?',
        'What was your role in the project?',
        'Did you have a functional specification? If not, did you encounter problems for this?',
        'Do you like the customer?',
        'Who is your favorite feature in the project?',
        'Is there something you did extremely well in this project?',
        'Is there anything that could be better next time?',
        'What would you change if you could rewrite the project?',
      ],
      sharePromptMessage:
        'Would you like to share something in the project Lexicon?',
      moreIdeasBtn: 'Give me other random ideas what I can share.',
      nextBtn: 'Okay. Finish!',
      shareMoreTitle: 'Share somethign else',
      wannaShareBtn: 'I want to share',
      skipShareBtn: ['Skip', 'Maybe another time', 'Nothing special happened'],
    },
  },
  project: {
    types: {
      default: '[Active]',
      side: '{Side}',
    },
    create: {
      nameLabel: 'Name',
      namePlaceholder: '',
      logoLabel: 'Logo. Square photos work best.',
      logoPlaceholder: '',
      descrLabel: 'Short description (1 tweet max size)',
      descrMemo: 'For the project Lexicon:',
      descrPlaceholder: '',
      descrPlaceholderMemo:
        'Limit: a bit longer than 2 tweets. Quick ideas what you could share: ',
      urlLabel: 'Functional specification URL',
      urlPlaceholder: 'https://...',
      urlsLabel: 'Other links, divided, by, a, comma',
      urlsPlaceholder:
        'Website? Repository? Trello? All useful project related links are welcome!',
      addBtn: 'Add',
      avatarUploadEdgeCase:
        "We saved the project successfully but there is a problem with the logo. Here's what we know: {{error}}. If you wish, try again by editing the project.",
    },
    edit: {
      editInfo: 'Edit project info',
      editInfoTitle: 'Edit Project Info',
      editInvolvementStatus: 'Change work status',
      editInvolvementStatusTitle: 'Change Your Work Status',
      addYourself: 'Join project',
      involvementStatus: {
        active: 'I actively work on this one.',
        inactive: 'I NO LONGER work on this one.',
        remove:
          'Delete the project from my account and remove the related history.',
        note:
          'Attention! If you simply are no longer working on this one, just mark the option above instead. It is important for the archive.',
      },
      notFound: 'This project no longer exists.',
    },
    join: {
      title: 'Joining Project',
      note:
        "Please confirm joining {{name}}. We're about to send the news to everyone shortly. :)",
      confirmBtn: 'Confirm! All good.',
      joinUserToProjectTitle: 'Join project',
      involvementStatus: {
        active: 'I actively work on this one.',
        inactive: "I've used to work on this one back in the days.",
      },
    },
    details: {
      title: 'Project info:',
      titleActivelyWorkingMembers: 'Users who actively work on this one:',
      titleInactivelyWorkingMembers:
        "Users who've been previously working on this one:",
    },
    memo: {
      title: 'Lexicon',
      noMemos:
        'Nobody has shared anything. Come on, be the first one to share! 🤗',
      btn: 'Share something',
      modalTitle: 'Share something related to this project 🤗',
      titleDate: 'Shared',
      thanksButtonText: ' says thanks that you shared.',
      thanksButtonText_plural: ' say thanks that you shared.',
      thanksButtonUsers: ' user',
      thanksButtonUsers_plural: ' users',
      thanksButtonAndMore: ' and',
      submitThanks: '... sending thanks',
      cancelThanks: '... taking your thanks back',
      submit: 'Send',
    },
    all: {
      activeProjectsTitlePrefix: '[Active] ',
      activeProjectsTitle: 'Projects ',
      activeProjectsTitleSuffix: '',
      activeSideProjectsTitlePrefix: '{Side} ',
      activeSideProjectsTitle: 'Projects',
      activeSideProjectsTitleSuffix: '',
      archievedProjectsTitlePrefix: '<!-- Inactive --> ',
      archievedProjectsTitle: 'Projects',
      archievedProjectsTitleSuffix: '',
    },
  },
  goal: {
    noGoals: 'No goals set.',
    create: {
      placeholder: 'Your S.M.A.R.T. goal',
      addGoal: '+ new goal',
      editGoalTooltip: 'Edit your goal',
      deleteGoalTooltip: 'Delete your goal',
      addUpdateTooltip: 'Share something related to your goal',
      goalDueDateTitle: 'I will complete the goal till the end of',
      smartGoalsTitle: 'What does S.M.A.R.T. goal mean?',
      specificDescr: 'Your goal should be clear and specific.',
      measurableDescr: "It's important to have measurable goals.",
      achievableDescr: 'Your goal also needs to be realistic and attainable.',
      relevantDescr: 'Ensure that your goal matters to you.',
      timeboundDescr: 'Every goal needs a target date.',
      learnMore: 'Learn more about S.M.A.R.T. goals',
    },
    memo: {
      modalTitle: 'Share something related to this goal 🤗',
      descrPlaceholderMemo: '...',
      descrMemo: 'My update',
      thanksButtonText: ' sent compliments.',
      thanksButtonText_plural: ' sent compliments.',
      submitThanks: '... sending compliments',
      cancelThanks: '... cancelling compliments',
    },
  },
  search: {
    placehoder: '... type name or project',
    titleUsers: '@Users',
    titleProjects: '@Projects',
    noProjectsFound: 'Ah! Nothing found.',
  },
  notFound: {
    title: 'Ah. Nothing found here. Error 404.',
  },
  expiredTokenTrick:
    'Your access token has expired. Auto-renewing the token is not implemented yet 🙄. Soooo, please re-login manually 🏃 by using the button below 👇',
  general: {
    error: 'Ah. 👷 Somethign went wrong 💥💥💥',
    okay: 'Ah, okay.',
    loading: 'Loading...',
    sending: 'Sending...',
    activate: 'Activate',
    login: 'Login',
    email: 'E-mail',
    password: 'Password',
    chooseProject: 'Choose a project',
    continue: 'Next',
    save: 'Save',
    saving: 'Saving...',
    cancel: 'Cancel',
    logout: 'Logout',
    saveChanges: 'Save changes',
    goHome: 'Go to Home',
    goArchive: 'Go to Archive',
    goGoals: 'Go see your goals',
    goProjects: 'Go see your projects',
    goProfile: 'Go to your profile',
    delete: 'Remove',
    oopsCancel: 'Ooops, mistake. Cancel it!',
    edit: 'Edit',
    functionalSpecification: 'Functional specification',
    and: 'and',
    doraName: 'Dora the Octopus',
    workInProgress: "That's still work in progress.",
    words: 'words',
    chars: 'characters',
  },
};



// WEBPACK FOOTER //
// ./src/translations/en.js